export const FirstFactorRoute: string = "/";
export const AuthenticatedRoute: string = "/authenticated";
export const ConsentRoute: string = "/consent";

export const SecondFactorRoute: string = "/2fa";
export const SecondFactorU2FRoute: string = "/2fa/security-key";
export const SecondFactorTOTPRoute: string = "/2fa/one-time-password";
export const SecondFactorPushRoute: string = "/2fa/push-notification";

export const ResetPasswordStep1Route: string = "/reset-password/step1";
export const ResetPasswordStep2Route: string = "/reset-password/step2";
export const RegisterSecurityKeyRoute: string = "/security-key/register";
export const RegisterOneTimePasswordRoute: string = "/one-time-password/register";
export const LogoutRoute: string = "/logout";
